// Only changed fields are written; the containing invitation map is never replaced.
const equal = (a, b) => JSON.stringify(a) === JSON.stringify(b);
export function buildInvitationSettingsPatch({ payload, originalInvitationData = {}, attachmentAction = "unchanged" }) {
  const { invitationData = {}, ...patch } = payload;
  for (const [key, value] of Object.entries(invitationData)) {
    if (key === "attachmentData") continue;
    if (!equal(value, originalInvitationData[key])) patch[`invitationData.${key}`] = value;
  }
  if (attachmentAction !== "unchanged") patch["invitationData.attachmentData"] = invitationData.attachmentData || { url: "", fileType: "" };
  return patch;
}
